class SearchEngine {
    constructor(application, apiKey, index, options) {
        this.client = algoliasearch(application, apiKey);
        this.index = this.client.initIndex(index);
        this.facets = options.facets;
        this.results = options.results;
        this.template = options.template;
        this.postType = options.postType;
        this.searchQuery = '';

        for(const facet of this.facets) {
            facet.bind(this);
        }

        this.update();
    }

    getGlobalFacetFilters() {
        let filters = '';

        if(this.postType) {
            filters += `type:"${this.postType}"`;
        }

        return filters;
    }

    async update() {
        // Build facet query
        const facetFilters = this.facets.map(facet => facet.getFilter()).filter(x => x);

        const { hits } = await this.index.search(this.searchQuery, {
            filters: [ this.getGlobalFacetFilters(), ...facetFilters ].join(' AND ')
        });

        const $children = hits.map(hit => this.template.render(hit));
        
        this.results.replaceChildren(...$children);
    }
}